import styled from 'styled-components';
import { device } from 'modules/Utils/Devices';

export const Footer = styled.footer`
  position: absolute;
  width: 100%;
  left: 0;
  text-align: center;
  ${(props) => props.theme.config.typograph.xsmall};
  bottom: ${(props) =>
    props.hasIdentifierEnv ? '7rem' : props.theme.config.spacing.spacing_4};
  color: ${(props) => props.theme.config.colors.text_base};
  padding-left: ${(props) => (props.$sidebarExpanded ? '26.4rem' : '9.2rem')};
  padding-right: 2.4rem;
  z-index: 1;
  transition: padding 0.2s ease-in;

  @media ${device.tablet} {
    padding-right: 2.4rem;
  }

  @media ${device.mobile} {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }
`;
